<template>
  <div id="page-wrapper">
    <div class="row">
      <div class="col-lg-6">
        <h1 class="page-header">{{$t('deposit.title')}}</h1>
      </div>
      <div class="col-lg-6">
        <total-balance :hideTotal="true" class="page-header align-r"></total-balance>
      </div>
      <!-- /.col-lg-12 -->
    </div>

    <div class="row" v-if="viewValidationMessage != 'ok'">
      <div class="col-md-12">
        <div
          class="alert alert-danger"
          role="alert"
          v-if="viewValidationMessage == 'incomplete_profile'"
        >
          <div v-html="$t('deposit.warnings.incomplete_profile')"></div>
        </div>
        <div v-if="viewValidationMessage == 'create_live_account'">
          <div class="alert alert-danger" role="alert">
            <div v-html="$t('deposit.warnings.you_should_have_a_live_account')"></div>
          </div>
          <div class="align-center">
            <spin-button
              id="btnCreateLiveAccount"
              :onClick="handleCreateMt4Account"
              :button-text="$t('deposit.create_live_account_now')"
              :loading="isLoading"
              :loading-text="$t('shared.buttons.creating_account')"
            ></spin-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="viewValidationMessage == 'ok' && model.mT4Account.accountType.mT4Server.isDemo">
      <div class="alert alert-danger" role="alert">
        <div v-html="$t('deposit.warnings.select_live_account')"></div>
      </div>
    </div>
    <div v-else>
      <div class="row roadmap">
        <div class="col-lg-offset-2 col-lg-8">
          <div class="row nav nav-tabs">
            <div class="col-sm-4">
              <a
                href="#payment"
                id="paymentHref"
                data-toggle="tab"
                :disabled="$v.model.pSPConfig.$invalid"
              >
                <div class="step first">
                  <span :class="$v.model.pSPConfig.$invalid ? '' : 'selected'">1</span>
                  <p>{{$t('deposit.payment_method')}}</p>
                </div>
              </a>
            </div>
            <div class="col-sm-4">
              <a href="#amount" id="amountHref" data-toggle="tab">
                <div class="step">
                  <span :class="!$v.model.amount.$invalid ? 'selected' : ''">2</span>
                  <p>{{$t('deposit.deposit_amount')}}</p>
                </div>
              </a>
            </div>
            <div class="col-sm-4">
              <a
                href="#summary"
                id="summaryHref"
                data-toggle="tab"
                :disabled="$v.model.amount.$invalid"
              >
                <div class="step last">
                  <span :class="isLastStep ? 'selected' : ''">3</span>
                  <p>{{$t('deposit.summary_and_payment')}}</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="panel panel-default">
          <div class="panel-heading panel-heading-color">
            <div class="pull-right information hidden-xs hidden-sm">
              <i class="fa fa-lock"></i>
              {{$t('deposit.all_transitions_are_safe_and_secure')}}
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane fade in active" id="payment">
          <!-- /.row -->
          <div class="row">
            <div class="panel panel-default">
              <div class="panel-heading panel-heading-color">{{$t('deposit.select_payment_method')}}</div>
              <!-- /.panel-heading -->
              <div class="panel-body deposit-options">
                <div class="row">
                  <div class="col-lg-4 col-xl-2" v-for="p in pspList">
                    <div
                      v-on:click="selectPSP(p)"
                      v-bind:class="p == model.pSPConfig ? 'deposit-option selected' : 'deposit-option'"
                    >
                      <img
                        :src="'/static/assets/images/deposit/' + p.id + '_' + $i18n.locale + '.png'"
                        alt="visa"
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group row buttons-r">
                  <div class="col-xs-12 col-md-offset-8 col-md-4">
                    <button
                      type="button"
                      v-on:click="goToStep('amount')"
                      :disabled="$v.model.pSPConfig.$invalid"
                      class="btn btn-primary mrg-r-15 mrg-b-25 v-button"
                    >{{$t('shared.buttons.next')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="amount">
          <!-- /.row -->
          <div class="row">
            <div class="panel panel-default">
              <component :is="selectedDepositOption" :options="model"></component>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="summary">
          <div class="panel panel-default panel-choose">
            <div class="panel-heading panel-heading-color">{{$t('deposit.summary_and_payment')}}</div>
            <!-- /.panel-heading -->
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-6">
                  <label>{{$t('deposit.payment_method_identificador')}}:</label>
                </div>
                <div class="col-xs-6">
                  <label>{{model.pSPConfig.description}}</label>
                </div>
                <div class="space-20"></div>
                <div class="col-xs-6">
                  <label>{{$t('deposit.mt4_account')}}:</label>
                </div>
                <div class="col-xs-6">
                  <label>{{model.mT4Account.login}}</label>
                </div>
                <div class="space-20"></div>
                <div class="col-xs-6">
                  <label>{{$t('deposit.currency')}}:</label>
                </div>
                <div class="col-xs-6">
                  <label>{{model.pSPConfig.currency}}</label>
                </div>
                <div class="space-20"></div>
                <hr>
                <div class="col-xs-6">
                  <label>Total:</label>
                </div>
                <div class="col-xs-6">
                  <label>{{model.amount}} {{model.pSPConfig.currency}}</label>
                </div>
              </div>
              <div class="form-group row buttons-r">
                <div class="col-xs-12 col-md-offset-6 col-md-6">
                  <button
                    type="button"
                    v-on:click="goToStep('amount')"
                    class="btn btn-default mrg-b-25"
                  >{{$t('shared.buttons.prev')}}</button>
                  <spin-button
                    v-bind:disabled="$v.model.$invalid"
                    id="btnSave"
                    :button-text="$t('shared.buttons.next')"
                    :loading="isLoading"
                    :loading-text="$t('shared.buttons.processing')"
                    :onClick="doDeposit"
                  ></spin-button>
                </div>
              </div>
            </div>
            <!-- /.panel-body -->
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import DepositService from "@/services/DepositService";
import AccountService from "@/services/AccountService";
import swal from "sweetalert2";
import AuthService from "@/services/AuthService";
import EventBus from "@/event-bus";
import GenericDepositOption from "@/components/GenericDepositOption";
import TheChangeDepositOption from "@/components/TheChangeDepositOption";
import BankDetailsDepositOption from "@/components/BankDetailsDepositOption";

import { required } from "vuelidate/lib/validators";
import siteConfiguration from '@/config';
const isDecimal = value => /^\d+(\.\d{1,2})?$/.test(value);
const isValidAmount = value => value > 0 && isDecimal;

let accountService = new AccountService();
let depositService = new DepositService();

export default {
  components: {
    GenericDepositOption,
    TheChangeDepositOption,
    BankDetailsDepositOption
  },
  data() {
    return {
      isLoading: false,
      isLastStep: false,
      selectedDepositOption: "GenericDepositOption",
      viewValidationMessage: "",
      model: {
        pSPConfig: {},
        amount: 0,
        currency: siteConfiguration.DEFAULT_CURRENCY,
        description: "",
        mT4Account: {},
        amounts : siteConfiguration.DEPOSIT_AMOUNTS
      },
      checkoutUrl: "",
      pspList: []
    };
  },
  methods: {
    doDeposit() {
      let t = this;
      t.isLoading = true;
      depositService
        .deposit(this.model)
        .then(r => {
          //var lightbox = lity(r.data, null, t);
          window.open(r.data, "_self");
        })
        .catch(error => {
          swal({
            position: "top-end",
            type: "error",
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 2000
          });
        })
        .finally(() => {
          t.isLoading = false;
        });
    },
    selectPSP(psp) {
      this.model.pSPConfig = psp;
      this.selectedDepositOption = psp.vueJsComponent;
      //console.log("---model---");
      //console.log(this.model);
      //console.log(this.selectedDepositOption);
    },
    doCancel() {
      this.$router.push("/client");
    },
    goToStep(step) {
      if (step) {
        this.isLastStep = step == "summary";
        let o = document.getElementById(step + "Href");
        if (o) {
          o.click();
        }
      }
    },
    handleCreateMt4Account() {
      swal({
        title: this.$t("shared.messages.creating_mt4_account"),
        text: this.$t("shared.messages.please_wait")
      });
      swal.showLoading();
      accountService
        .createMT4LiveAccount()
        .then(r => {
          EventBus.$emit("onSetDefaultMt4Account", r.data);
        })
        .catch(e => {
          swal({
            type: "error",
            title: "Error",
            text: e.response
          });
        })
        .finally(r => {
          swal.close();
        });
    },
    setAmount(amount) {
      this.model.amount = amount;
    },
    validateAndPopulateView(account) {

      swal({
        title: this.$t("deposit.loading_payment_methods"),
        text: this.$t("shared.messages.please_wait")
      });
      
      swal.showLoading();

      if (account != null){
        this.model.mT4Account = account;
        depositService.getViewValidationMessage().then(r=>{
          return r;
        }).then((r) => {
            this.viewValidationMessage = r.data;
            if (r.data === "ok") {
              depositService.getPSPList().then(r => {
                  this.pspList = r.data;
              })
              .catch(e => {
                alert(e.response);
              });
            }
        }).finally((r) => {
            swal.close();
        });
      }else{
        accountService.getDefaultMt4Account().then((r) => {
          this.model.mT4Account = r.data;
          return r;
        }).then((r) =>{
            return depositService.getViewValidationMessage();
        }).then((r) => {
            this.viewValidationMessage = r.data;
            if (r.data === "ok") {
              depositService.getPSPList().then(r => {
                  this.pspList = r.data;
              })
              .catch(e => {
                alert(e.response);
              });
            }
        }).finally((r) => {
            swal.close();
        });
      }
    },
    populateCompronent(account){
       accountService.getDefaultMt4Account().then((r) => {
        this.model.mT4Account = r.data;
       });
    }
  },
  created() {

    EventBus.$on('onUpdateDefaultMt4Account', account =>{
        this.validateAndPopulateView(account);
    });

    if (this.$route.params && this.$route.params.amount > 0) {
      this.setAmount(this.$route.params.amount);
    }
    
    EventBus.$on("onGoToStep", step => {
      this.goToStep(step);
    });

    this.validateAndPopulateView(null);
  },
  validations: {
    model: {
      pSPConfig: {
        required
      },
      amount: {
        required,
        numberValid: isDecimal,
        isValidAmount
      }
    }
  }
  //updated() {
   // if (this.pspList[0]) {
    //  this.model.pSPConfig = this.pspList[0];
     // this.selectedDepositOption = this.pspList[0].vueJsComponent;
     // this.goToStep('amount')
   // }
  //}
};
</script>



// WEBPACK FOOTER //
// src/components/views/Deposit.vue